export default __webpack_public_path__ + "static/media/bg2.5fc07251.jpg";